// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__KlJoO","tooltipText":"Tooltip_tooltipText__exuTC","visible":"Tooltip_visible__W9jSV","fadein":"Tooltip_fadein__E1c_g","fadeout":"Tooltip_fadeout__I2HNi"};